<template>
   <div>
      <omni-chat></omni-chat>
   </div>
</template>

<script>
</script>